import { DialogActions, FormControl, Grid, Toolbar } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import PropTypes from "prop-types";
import React from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";

import { mapActionsToProps } from "../../redux/agent";
import { globalHistory } from "./../../history";

function TabContainer(props) {
  return <React.Fragment>{props.children}</React.Fragment>;
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  toolbar: {
    paddingLeft: theme.spacing.unit,
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  grid: {
    width: "100%",
    padding: theme.spacing.unit * 3,
  },
  chip: {
    margin: theme.spacing.unit,
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
  tabContainer: {
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    padding: theme.spacing.unit * 5,
  },
});

class CreateGroupAgent extends React.Component {
  state = {
    value: "employeeGroups",
    filters: {
      order: "createdAt DESC",
      where: {},
    },
    name: "",
    note: "",
  };

  componentDidMount() {
    this.history = globalHistory();
  }

  handleChangeTab = (event, value) => {
    this.setState({ value });
  };

  handleChangeText = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.value,
      });
    };
  };

  handleSubmit = () => {
    this.props.addNewGroupAgent(this.state.name, this.state.note);
  };

  clear = () => {
    this.setState({ name: "", note: "" });
  };

  render() {
    const { value, filters, name, note } = this.state;
    const { classes } = this.props;
    return (
      <Paper className={classes.root}>
        <Toolbar className={classes.toolbar}>
          <span className={classes.breadCrumb}>
            <Button
              size="small"
              disableRipple={true}
              onClick={() => this.history.push("/agent-group")}>
              <ArrowBackIos color="primary" />
              Danh sách nhóm điện thoại viên
            </Button>
          </span>
          <div style={{ flexGrow: 1 }}></div>
        </Toolbar>

        <div style={{ overflowX: "auto" }}>
          <ValidatorForm
            ref="form"
            onSubmit={this.handleSubmit}
            onError={(errors) => console.log(errors)}
            className={classes.form}>
            <FormControl className={classes.form}>
              <Grid container className={classes.grid}>
                <TextValidator
                  id="outlined-full-width"
                  margin="normal"
                  label="Tên nhóm"
                  variant="outlined"
                  className={classes.input}
                  onChange={this.handleChangeText("name")}
                  value={name}
                  name="name"
                  validators={["required"]}
                  errorMessages={[`Không được để trống`]}
                />

                <TextValidator
                  id="outlined-full-width"
                  margin="normal"
                  label="Ghi chú"
                  variant="outlined"
                  className={classes.input}
                  onChange={this.handleChangeText("note")}
                  value={note}
                  name="note"
                  multiline
                  rows={5}
                  validators={["required"]}
                  errorMessages={[`Không được để trống`]}
                />
              </Grid>
            </FormControl>
            <DialogActions>
              <Button
                onClick={this.clear}
                variant="contained"
                color="primary"
                className={classes.button}>
                Hủy
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                className={classes.button}>
                Lưu
              </Button>
            </DialogActions>
          </ValidatorForm>
        </div>
      </Paper>
    );
  }
}

CreateGroupAgent.propTypes = {
  classes: PropTypes.object.isRequired,
};

CreateGroupAgent = connect(null, mapActionsToProps)(CreateGroupAgent);

export default withStyles(styles)(CreateGroupAgent);
